import { render, staticRenderFns } from "./CreateTournament.vue?vue&type=template&id=b6710912&"
import script from "./CreateTournament.vue?vue&type=script&lang=js&"
export * from "./CreateTournament.vue?vue&type=script&lang=js&"
import style0 from "./CreateTournament.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports